"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputPropertiesSchema = void 0;
var yup = __importStar(require("yup"));
var Core_schema_1 = require("./Core.schema");
exports.inputPropertiesSchema = yup
    .object({
    label: yup.string(),
    required: yup.boolean().default(false),
    autoFocus: yup.boolean().default(false),
    readOnly: yup.boolean().default(false),
    tabIndex: yup.number(),
    inputHeight: yup.number().notRequired(),
    inputHeightMobile: yup.number().notRequired(),
    labelMargin: yup.number().default(14),
    labelPadding: yup.number().default(0),
})
    .concat(Core_schema_1.disableableProperties);
//# sourceMappingURL=Input.schema.js.map